
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const STATS = [
  { value: '15+',   label: 'Years experience' },
  { value: '1,500+',label: 'Learners trained' },
  { value: '25+',   label: 'Corporate clients' },
];

export default function HeroSection() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 80);
    return () => clearTimeout(t);
  }, []);

  const fade = (delay: string) =>
    `transition-all duration-700 ${delay} ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`;

  return (
    <section className="relative min-h-[100svh] flex flex-col overflow-hidden bg-[#1A3A22]">

      {/* Background photo — right half */}
      <div className="absolute inset-0 lg:left-[48%]">
        <div
          className="w-full h-full bg-cover bg-center"
          style={{
            backgroundImage: `url('/hero.png')`
          }}
        />
        {/* Photo overlay — dark on left edge to blend with green panel */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#1A3A22] via-[#1A3A22]/60 to-transparent lg:from-[#1A3A22] lg:via-[#1A3A22]/20 lg:to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex-1 flex items-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 w-full">
          <div className="max-w-xl">

            {/* Headline */}
            <h1 className={`font-serif font-normal text-white leading-[1.08] mb-6 ${fade('delay-100')}`}
              style={{ fontSize: 'clamp(2.6rem, 6vw, 4.5rem)', color: 'white' }}>
              Transforming<br />
              <span className="text-[#5EC97A]">Potential</span> into<br />
              Performance
            </h1>

            {/* Divider */}
            <div className={`w-14 h-0.5 bg-[#5EC97A] mb-6 transition-all duration-700 delay-200 origin-left ${visible ? 'opacity-100 scale-x-100' : 'opacity-0 scale-x-0'}`} />

            {/* Body */}
            <p className={`text-white/70 text-base leading-relaxed mb-10 max-w-[440px] ${fade('delay-300')}`}>
              South Africa's trusted partner for accredited skills development, SETA compliance, and workforce empowerment — backed by 15+ years of proven results.
            </p>

            {/* CTAs */}
            <div className={`flex flex-wrap gap-3 mb-14 ${fade('delay-[400ms]')}`}>
              <Link to="/contact">
                <button className="btn btn-primary btn-lg">
                  <i className="ri-calendar-check-line mr-2" />
                  Book Free Consultation
                </button>
              </Link>
              <Link to="/programmes">
                <button className="btn btn-ghost btn-lg">
                  View Programmes
                  <i className="ri-arrow-right-line ml-2" />
                </button>
              </Link>
            </div>

          </div>
        </div>
      </div>

      {/* Stats bar */}
      <div className="relative z-10 bg-[#0c2414]/70 backdrop-blur-sm border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-3 divide-y sm:divide-y-0 sm:divide-x divide-white/10">
            {STATS.map((s, i) => (
              <div key={i} className="py-5 px-6 text-center">
                <div className="text-white font-serif font-bold text-2xl leading-none mb-1">{s.value}</div>
                <div className="text-white/50 text-xs uppercase tracking-wider">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
